<template>
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-offset-4 col-md-4">
            <card>
                <div class="header">
                    <h4 class="title">Editar Perfil</h4>
                </div>
                <div class="content">
                    <form @submit.prevent.stop='edit()'>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Nome</label>
                                    <input type="text" v-model="user.name" name='name' class="form-control border-input" required placeholder="Nome">
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                          <button type="submit" @click="save()" class="btn btn-info btn-fill btn-wd">Salvar</button>
                        </div>
                        <div class="clearfix"></div>
                    </form>
                </div>
            </card>
        </div>
    </div>
    </div>
</template>
<script>
import UsersService from '../services/users-service'

export default {

  data () {
    return {
      user: {
        name: ''
      },
    }
  },

  mounted () {
    UsersService.getMe()
      .then(response => response.data)
      .then(user => { this.user = user })
  },
  methods: {
    save () {
      UsersService.saveMe(this.user);
    }
  }

}
</script>
<style scoped>
    .troll-face {
        width: 100px;
        cursor: not-allowed;
    }
</style>

